"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Clothing = Clothing;
exports.CreditCards = CreditCards;
exports.FixedLoans = FixedLoans;
exports.GiftsToOthers = GiftsToOthers;
exports.Other = Other;
exports.PersonalCare = PersonalCare;
exports.PetCare = PetCare;
var _react = _interopRequireDefault(require("react"));
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _RetirementIncomeGapWizardCalc = require("./RetirementIncomeGapWizardCalc.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Clothing(_ref) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref;
  var fieldName = 'personal_clothing';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Clothing',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function PersonalCare(_ref2) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref2;
  var fieldName = 'personal_personalCare';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Personal Care (e.g. Hair, Skin, Nails, etc.)',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function CreditCards(_ref3) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref3;
  var fieldName = 'personal_creditCards';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Credit Cards',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function FixedLoans(_ref4) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref4;
  var fieldName = 'personal_fixedLoans';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Fixed Loans (e.g. Personal Loans, Student Loans)',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function GiftsToOthers(_ref5) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref5;
  var fieldName = 'personal_giftsToOthers';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Gifts to Others',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function PetCare(_ref6) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref6;
  var fieldName = 'personal_petCare';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Pet Care',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function Other(_ref7) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref7;
  var fieldName = 'personal_otherPersonalExpenses';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Other',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}